/* eslint-disable jsx-a11y/no-autofocus */
import React, { Fragment } from 'react';
import pt from 'prop-types';

import { slugify } from 'utils';
import { countryOptions } from 'utils/geo';
import { BUDGET_OPTIONS } from 'partners/shared/budget';

import Button from 'components/button';
import { Form, Field } from 'components/form';
import { FadeInPop } from 'components/transitions';

import './signup.scss';

const { PARTNER_HOST } = process.env;
const NAME_TAKEN_ERROR = 'Company name is already taken';

const FIELD = 'login-form-field-margin-16';
const FIELD_LEFT = `span2 login-form-field-padding-right-8 ${FIELD}`;
const FIELD_RIGHT = `span2 login-form-field-padding-left-8 ${FIELD}`;

export default class SignupDetails extends React.PureComponent {
  static propTypes = {
    values: pt.object,
    errors: pt.object,
    takenPartnerId: pt.string,
    onChangePartnerName: pt.func,
    onSubmit: pt.func,
  };

  constructor(props) {
    super(props);

    this.state = { values: { ...props.values } };
  }

  onFormChange = (values) => {
    this.setState({ values });
  };

  renderNameError() {
    const { errors, takenPartnerId } = this.props;
    const error = errors.name;

    if (error !== NAME_TAKEN_ERROR) {
      return error;
    }

    const loginUri = takenPartnerId ? `/${takenPartnerId}/login` : '/login';

    return (
      <Fragment>
        {error}. Are you the owner? <a href={loginUri}>Log in!</a>
      </Fragment>
    );
  }

  renderNameHint() {
    if (this.props.errors.name) {
      return undefined;
    }

    const { name } = this.state.values;

    return (
      <p>
        https://{PARTNER_HOST}/
        <b>{name ? slugify(name) : 'your-company-name'}</b> will be your
        dashboard address.
        <br /> This can&rsquo;t be changed later.
      </p>
    );
  }

  render() {
    const { onChangePartnerName, onSubmit } = this.props;
    const { name, budget, agree } = this.state.values;
    const business = this.state.values.business || {};
    const social = this.state.values.social || {};

    return (
      <FadeInPop>
        <div>
          <div className="signup-header">
            <div className="signup-subtitle">
              Enter your company details below
            </div>
          </div>

          <Form
            onChange={this.onFormChange}
            onSubmit={onSubmit}
            autoFocus={true}
            autoFocusEmpty={true}
          >
            <fieldset>
              <Field
                type="text"
                name="name"
                label="Company name"
                required={true}
                maxLength={32}
                large={true}
                onChange={onChangePartnerName}
                error={this.renderNameError()}
                defaultValue={name}
                autoFocus={true}
                hintOnFocus={this.renderNameHint()}
                className={FIELD}
              />

              <Field
                type="text"
                name="business.website"
                label="Company website"
                rules="url"
                required={true}
                large={true}
                defaultValue={business.website}
                className={FIELD}
              />

              <div className="row">
                <Field
                  type="select"
                  name="business.country"
                  label="Country (optional)"
                  options={countryOptions}
                  large={true}
                  defaultValue={business.country}
                  className={FIELD_LEFT}
                />

                <Field
                  type="select"
                  name="budget"
                  label="Budget (optional)"
                  options={BUDGET_OPTIONS}
                  large={true}
                  defaultValue={budget}
                  className={FIELD_RIGHT}
                />
              </div>

              <div className="row">
                <Field
                  type="text"
                  name="social.twitter"
                  label="X (optional)"
                  large={true}
                  defaultValue={social.twitter}
                  className={FIELD_LEFT}
                />

                <Field
                  type="text"
                  name="social.linkedin"
                  label="LinkedIn (optional)"
                  large={true}
                  defaultValue={social.linkedin}
                  className={FIELD_RIGHT}
                />
              </div>

              <div className="row">
                <Field
                  type="text"
                  name="social.instagram"
                  label="Instagram (optional)"
                  large={true}
                  defaultValue={social.instagram}
                  className={FIELD_LEFT}
                />

                <Field
                  type="text"
                  name="social.youtube"
                  label="YouTube (optional)"
                  large={true}
                  defaultValue={social.youtube}
                  className={FIELD_RIGHT}
                />
              </div>

              <Field
                type="checkbox"
                name="agree"
                label={
                  <span>
                    I&rsquo;ve read and agree to the{' '}
                    <a
                      rel="noreferrer"
                      href="https://www.swell.is/legal/partner-program-agreement"
                      target="_blank"
                      className="signup-link"
                      onClick={onLinkClick}
                    >
                      Partner Agreement
                    </a>
                    .
                  </span>
                }
              />
            </fieldset>

            <div className="signup-actions">
              <Button
                size="large"
                type="submit"
                className="signup-submit"
                disabled={!agree}
              >
                Next
              </Button>
            </div>
          </Form>
        </div>
      </FadeInPop>
    );
  }
}

function onLinkClick(event) {
  event.stopPropagation();
}
